import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { JSONTree } from 'react-json-tree';
import getItemString from './getItemString.js';
import getJsonTreeTheme from './getJsonTreeTheme.js';
const ActionTab = ({ action, base16Theme, invertTheme, labelRenderer, dataTypeKey, isWideLayout, }) => (_jsx(JSONTree, { labelRenderer: labelRenderer, theme: getJsonTreeTheme(base16Theme), data: action, getItemString: (type, data) => getItemString(type, data, dataTypeKey, isWideLayout), invertTheme: invertTheme, hideRoot: true }));
export default ActionTab;
